"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxyFor = exports.DATADOG_SITE = void 0;
exports.DATADOG_SITE = "datadoghq.eu";
const proxyFor = ({
  environment,
  path,
  parameters
}) => {
  const rootUrl = environment === "production" ? "https://www.storebrand.no/dd" : "https://www-t.storebrand.no/dd";
  return `${rootUrl}/${path}?${decodeURI(parameters)}`;
};
exports.proxyFor = proxyFor;
